import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { DatasetActions } from '@mode/dataset/contract';

@Injectable({ providedIn: 'root' })
export class MoveSpacePublishService {
  private publishSpaceMoveSubject = new Subject<string>();
  publishMove$ = this.publishSpaceMoveSubject.asObservable();

  constructor(private store: Store) {}

  triggerPublishMoveSpace(switchViewToken: string) {
    this.publishSpaceMoveSubject.next(switchViewToken);
  }

  publishDatasetAfterMoveSpace(switchViewToken: string) {
    this.store.dispatch(DatasetActions.publishDatasetAfterMoveSpace({ switchViewToken }));
  }
}
